import { render, staticRenderFns } from "./SendMultipleLacksModal.vue?vue&type=template&id=2846de9e"
import script from "./SendMultipleLacksModal.vue?vue&type=script&lang=js"
export * from "./SendMultipleLacksModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports